import type { Metadata, PaginationParams } from '@/types';
import type { MeetingType } from '../../types';

import { axiosClient } from '@/lib/axios';
import { QueryFunction, useQuery } from '@tanstack/react-query';

type ResponseData = {
  data: MeetingType[];
  metadata: Metadata;
};

type Params = {
  companyID: number;
  queryParams?: {
    sort_by?: keyof MeetingType;
    sort_dir?: 'asc' | 'desc';
    q?: string;
  } & PaginationParams;
};

export const getMeetingTypes = async ({ companyID, queryParams }: Params): Promise<ResponseData> => {
  const { data } = await axiosClient.get<ResponseData>(`/companies/${companyID}/meetings/meeting-types`, {
    params: queryParams,
  });

  return data.data.length
    ? data
    : {
        data: Array(10)
          .fill(0)
          .map((_, i) => ({
            id: i,
            name: `meeting type ${i}`,
          })),
        metadata: {
          current: 1,
          total: 10,
          size: 10,
        },
      };
};
type QueryFnType = typeof getMeetingTypes;

type UseGetMeetingTypesOptions = {
  companyID: number;
  queryParams?: Params['queryParams'];
  config?: QueryFunction<QueryFnType>;
};

export const useGetMeetingTypes = ({ companyID, queryParams, config }: UseGetMeetingTypesOptions) => {
  return useQuery({
    queryKey: ['meeting-types', companyID, queryParams],
    queryFn: () => getMeetingTypes({ companyID, queryParams }),
    ...config,
  });
};
